// data.js - Shared data for GeriCall Demo

export const SHARED_PERSONAS = {
  zorginstellingBestuurder: {
    id: 'zib',
    naam: 'Zorginstelling Bestuurder',
    organisatie: 'Zorginstelling',
    beschrijving: 'Neemt strategische beslissingen, tekent contracten',
    frequentie: 'Maandelijks/Kwartaal',
    rol: 'Beslisser',
    icon: 'building2',
    uitdagingen: [
      'Weinig direct contact met GeriCall',
      'Zoekt naar kostenefficiëntie',
      'Wil inzicht in ROI van outsourcing'
    ],
    behoeften: [
      'Executive summaries',
      'Benchmark met andere instellingen',
      'Transparante kosten-baten analyse'
    ],
    kpis: ['Kostenreductie', 'Kwaliteitsscore', 'Medewerkertevredenheid'],
    mockups: [],
    toekomstigScherm: 'Executive Dashboard'
  },
  zorginstellingManager: {
    id: 'zim',
    naam: 'Manager Behandeldienst',
    organisatie: 'Zorginstelling',
    beschrijving: 'Verantwoordelijk voor dagelijkse operatie en kwaliteit van behandeldienst',
    frequentie: 'Wekelijks',
    rol: 'Domein Manager',
    icon: 'barChart3',
    uitdagingen: [
      'Geen inzicht in performance per huis',
      'Handmatig rapportages maken',
      'Reactief ipv proactief sturen'
    ],
    behoeften: [
      'Dashboard met alle huizen',
      'Overdag-arts performance metrics',
      'Bewonertevredenheid scores'
    ],
    kpis: ['Nachtconsults reductie', 'Huis performance', 'CSAT score'],
    mockups: [],
    toekomstigScherm: 'Zorginstelling Manager Dashboard'
  },
  teamManager: {
    id: 'tm',
    naam: 'Team Manager',
    organisatie: 'Zorginstelling',
    beschrijving: 'Zorgt dat GeriCall bezetting klopt voor het huis',
    frequentie: 'Dagelijks',
    rol: 'Operationeel Manager',
    icon: 'clipboardCheck',
    uitdagingen: [
      'Wil zekerheid dat GeriCall bezet is',
      'Geen real-time inzicht',
      'Belt vaak om te checken'
    ],
    behoeften: [
      'Bezettingsoverzicht per avond',
      'Notificaties bij wijzigingen',
      'Direct contact met planner'
    ],
    kpis: ['Bezettingszekerheid', 'Response tijd', 'Communicatie score'],
    mockups: [],
    toekomstigScherm: 'Team Manager Dashboard'
  },
  verzorgende: {
    id: 'vz',
    naam: 'Verzorgende',
    organisatie: 'Zorginstelling',
    beschrijving: 'Directe zorgverlener, meldt zorgvragen',
    frequentie: 'Meerdere keren per dienst',
    rol: 'Zorgverlener',
    icon: 'user',
    uitdagingen: [
      'Bellen kost veel tijd (5-10 min)',
      'Moet veel herhalen aan arts',
      'Weet niet wat urgentie is'
    ],
    behoeften: [
      'Snelle intake (< 1 min)',
      'NTS-guided vragen',
      'Voice-to-text'
    ],
    kpis: ['Tijd per intake', 'Urgentie accuratesse', 'User satisfaction'],
    mockups: ['intake-app'],
    huidigeSchermen: ['GeriCall Intake App (NTS)']
  },
  planner: {
    id: 'pl',
    naam: 'Planner',
    organisatie: 'GeriCall',
    beschrijving: 'Zorgt voor bezetting alle diensten',
    frequentie: 'Dagelijks',
    rol: 'Coördinator',
    icon: 'calendar',
    uitdagingen: [
      'Handmatig artsen benaderen',
      'Last-minute uitval opvangen',
      'Geen data over voorkeuren'
    ],
    behoeften: [
      'Overzicht open diensten',
      'Arts beschikbaarheid real-time',
      'Auto-notificaties naar artsen'
    ],
    kpis: ['Bezettingsgraad', 'Tijd tot bezetting', 'Uitval count'],
    mockups: [],
    toekomstigScherm: 'Planner Dashboard'
  },
  voorwachtArts: {
    id: 'va',
    naam: 'Arts (ANW / Dagdienst)',
    organisatie: 'GeriCall',
    beschrijving: 'Voert consulten uit en stelt diagnoses. Werkt in ANW-diensten of dagdienst.',
    frequentie: 'Continu tijdens dienst',
    rol: 'Behandelaar',
    icon: 'stethoscope',
    uitdagingen: [
      'Diagnose stellen op afstand',
      'Wisselende patiënten zonder eigen historie',
      'Medicatie voorschrijven zonder fysiek onderzoek',
      'Snel schakelen tussen cases'
    ],
    behoeften: [
      'Complete medische voorgeschiedenis',
      'Actuele medicatielijst',
      'Video consultatie mogelijkheid',
      'Snel recept uitschrijven'
    ],
    kpis: ['Consults per dienst', 'Handling tijd', 'Documentatie volledigheid', 'Kudos'],
    mockups: ['arts-dashboard', 'arts-mobile'],
    huidigeSchermen: ['GeriCall Arts Dashboard', 'GeriCall Arts Mobile App']
  },
  specialist: {
    id: 'sp',
    naam: 'Verpleegkundig Specialist TT',
    organisatie: 'GeriCall',
    beschrijving: 'Geeft verpleegkundig advies en escaleert naar arts indien nodig',
    frequentie: 'Op aanvraag',
    rol: 'Adviseur TT',
    icon: 'brain',
    uitdagingen: [
      'Complexe cases zonder context',
      'Moet snel beslissen over escalatie',
      'Veel administratie bij overdracht'
    ],
    behoeften: [
      'Volledige case historie',
      'Directe lijn met behandelend arts',
      'Protocollen bibliotheek'
    ],
    kpis: ['Escalatie accuratesse', 'Advies kwaliteit', 'Response tijd'],
    mockups: [],
    toekomstigScherm: 'Specialist Dashboard'
  }
};

export const SHARED_COMMENTS = {};

export const SHARED_JOURNEY_STAGES = [
  {
    id: 'stage_1',
    stage: 'Zorgbehoefte',
    beschrijving: 'Verzorgende besluit contact op te nemen met GeriCall tbv consult arts',
    links: []
  },
  {
    id: 'stage_2',
    stage: 'Triage & Routing',
    beschrijving: 'Consult wordt getrieerd en gerouteerd',
    links: []
  },
  {
    id: 'stage_3',
    stage: 'Zorgverlening',
    beschrijving: 'Arts verleent zorg',
    links: []
  },
  {
    id: 'stage_4',
    stage: 'Monitoring',
    beschrijving: 'Kwaliteit en performance monitoring',
    links: []
  },
  {
    id: 'stage_5',
    stage: 'Sturing',
    beschrijving: 'Strategische beslissingen',
    links: []
  }
];

export const SHARED_JOURNEY_BUNDLES = [];
